// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1zkLl","empty":"styles_empty__12kdB","scroll":"styles_scroll__4v4XS"};